var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.date_warning)?_c('div',{staticClass:"mt-3",attrs:{"role":"alert"}},[_c('p',{staticStyle:{"color":"#FA8300"}},[_vm._v(_vm._s(_vm.date_warning))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }